<!--- Formulario FrmWorkerRecords ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page class="main-repairs-interventions">
    <template #fixed>
      <TheNavbar
        nav-title="Partes de reparación"
        back-btn-enable
      />
    </template>

    <f7-block class="block-workerSelected">
      <!-- Datos Trabajador Seleccionado -->
      <PCWorkerPresenceCard
        v-if="selectedWorker != null"
        :selected-worker="selectedWorker"
      />
    </f7-block>
    <f7-block>
      <UCSearchEntityERP
        ref="UCWorkersComponent"
        :title="$t('searchEntity.worker.title.workerSearch')"
        :placeholder="$t('searchEntity.worker.placeholder.numberNameFirstLastName')"
        :search-text="$t('searchEntity.worker.searchText')"
        :search-cancellation-text="$t('searchEntity.worker.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.worker.searchNotFoundText')"
        :end-point-for-code-search="GetWorkerCodeSearch"
        :end-point-for-list="GetWorkerList"
        :property-entity-shown-input="['Codigo', 'Sujeto.NombreSujeto']"
        :property-entity-shown-list-title="['Sujeto.NombreSujeto']"
        :property-entity-shown-list-subtitle="['Codigo']"
        :min-text-search="1"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        :qr-search-show="true"
        :qr-search-params="{
          showInputButton: true,
          fabButtonShow: false,
          allowManualCodeEntry: false,
        }"
        @selection="EventSelectedWorker"
      />
    </f7-block>
    <f7-block>
      <UCSearchEntityERP
        title="Búsqueda de parte de reparación"
        placeholder="Serie/Numero o Código parte de reparación"
        search-text="Buscando parte de producción"
        search-cancellation-text="Búsqueda parte de producción cancelada…"
        search-not-found-text="Parte Producción no encontrado"
        :end-point-for-code-search="GetPartOfProductionCodeSearch"
        :property-entity-shown-input="['Serie', 'Numero']"
        :property-entity-shown-list-title="['Sujeto.NombreSujeto']"
        :property-entity-shown-list-subtitle="['Codigo']"
        :default-value="selectedPartOfProduction"
        :min-text-search="2"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        :separation-character="[' / ']"
        :qr-search-show="true"
        :qr-search-params="{
          showInputButton: true,
          fabButtonShow: false,
          allowManualCodeEntry: false,
        }"
        :disabled="selectedWorker === null || parteProduccionRealTrabajadorActivo != null"
        :disabled-qr="selectedWorker === null || parteProduccionRealTrabajadorActivo != null"
        @selection="EventSelectedPartOfProduction"
      />
    </f7-block>

    <f7-block>
      <UCSearchEntityERP
        :title="$t('searchEntity.line.title.selectProductionLine')"
        :placeholder="$t('searchEntity.line.placeholder.codeLine')"
        :search-text="$t('searchEntity.line.searchText')"
        :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
        :default-etities-list="listProductionLine"
        :property-entity-shown-input="['Codigo', 'Nombre']"
        :property-entity-shown-list-title="['Codigo']"
        :property-entity-shown-list-subtitle="['Nombre']"
        :default-value="selectedLineOfProduction"
        class="padding-bottom-half"
        :disabled="selectedPartOfProduction === null || parteProduccionRealTrabajadorActivo != null"
        @selection="EventSelectedProductionLine"
      />
    </f7-block>

    <f7-block>
      <div
        class="card card-outline margin-top"
        :class="{ 'disabled-component': !selectedPartOfProduction }"
      >
        <div class="card-header">
          Descripción del parte de reparación
        </div>
        <div
          class="
                    card-content card-content-padding
                    no-padding-top
                    margin-top-half
                  "
        >
          <textarea
            disabled="true"
            name="textarea"
            rows="5"
            cols="50"
            :value="selectedPartOfProduction != null ? selectedPartOfProduction.Descripcion : ''"
          />
        </div>
      </div>
    </f7-block>

    <f7-block>
      <div class="card card-outline margin-top">
        <div class="card-header color-oliva">
          Opciones parte reparación
        </div>
        <div
          class="
                    card-content card-content-padding
                    no-padding-top
                    margin-top-half
                  "
        >
          <f7-button
            :disabled="!enableInitPart || enableFinishPart"
            fill
            color="oliva"
            class="margin-top-half"
            @click="InitProductionPart"
          >
            INICIAR PARTE
          </f7-button>
          <f7-col>
            <f7-button
              :disabled="!enableFinishPart || enableInitPart"
              fill
              small
              color="orange"
              class="margin-top-half"
              @click="FinishProductionPart"
            >
              FINALIZAR PARTE
            </f7-button>
          </f7-col>
        </div>
      </div>
    </f7-block>
  </f7-page>
</template>

<script>
import { mapWritableState } from 'pinia';
import { usePresenceStore } from '@/js/stores/presence';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import PCWorkerPresenceCard from '@/components/presence/workerRecords/PCWorkerPresenceCard.vue';
import APIErp from '@/js/services/APIErp';
import TheNavbar from '@/components/TheNavbar.vue';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';

export default {
  name: 'FrmRepairsInterventions',
  components: {
    UCSearchEntityERP,
    PCWorkerPresenceCard,
    TheNavbar,
  },
  props: {
    // Trabajador seleccionado al inicializar el formulario.
    workerSelectedDefault: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedPartOfProduction: null,
      listProductionLine: [], /* [{ Id: '1', Nombre: 'Prueba', Codigo: 'COD1' }, { Id: '2', Nombre: 'Prueba2', Codigo: 'COD2' }], */
      selectedLineOfProduction: null,
      parteProduccionRealTrabajadorActivo: null,
    };
  },
  computed: {
    ...mapWritableState(usePresenceStore, ['selectedWorker']),

    enableInitPart() {
      if (this.selectedWorker != null
        && this.selectedPartOfProduction != null
        && this.selectedLineOfProduction != null
        && this.parteProduccionRealTrabajadorActivo == null
      ) {
        return true;
      }
      return false;
    },
    enableFinishPart() {
      if (this.selectedWorker != null
        && this.selectedPartOfProduction != null
        && this.selectedLineOfProduction != null
        && this.parteProduccionRealTrabajadorActivo != null
      ) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    this.StartForm();
  },
  beforeUnmount() {
    this.selectedWorker = null;
  },
  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      if (this.workerSelectedDefault !== undefined && this.workerSelectedDefault != null) {
        this.$refs.UCWorkersComponent.SelectEntity(this.workerSelectedDefault, true);
      }
    },

    GetWorkerCodeSearch(params) {
      Log(this, this.GetWorkerCodeSearch.name);
      return APIErp.callWorkerSearchText(params);
    },
    GetWorkerList() {
      Log(this, this.GetWorkerList.name);
      return APIErp.callWorkerList();
    },
    GetPartOfProductionCodeSearch(params) {
      Log(this, this.GetPartOfProductionCodeSearch.name);
      return APIErp.callPartOfProductionText(params);
    },
    async EventSelectedWorker(objWorker) {
      Log(this, this.EventSelectedWorker.name);
      this.selectedWorker = objWorker;
      if (objWorker === null) {
        this.selectedPartOfProduction = null;
        this.listProductionLine = [];
        this.selectedLineOfProduction = null;
        this.parteProduccionRealTrabajadorActivo = null;
        return;
      }
      HiDialog.Preloader(true, 'Consultando intervenciones activas trabajador', true, 'Consulta cancelada');
      const lstPart = await this.Conections_GetActiveWorkerProductionPart(objWorker);
      HiDialog.Preloader(false);
      if (lstPart != null && lstPart.length === 1) {
        this.EventSelectedPartOfProduction(lstPart[0]);
        this.parteProduccionRealTrabajadorActivo = this.selectedPartOfProduction.ParteProduccionReal.Trabajadores
          .find((pprt) => pprt.Trabajador.Id === this.selectedWorker.Id
            && pprt.EnCurso === true);
        if (this.parteProduccionRealTrabajadorActivo != null) {
          this.selectedLineOfProduction = this.parteProduccionRealTrabajadorActivo.LineaProduccion;
        }
      } else {
        this.selectedPartOfProduction = null;
        this.listProductionLine = [];
        this.selectedLineOfProduction = null;
      }
    },
    async EventSelectedPartOfProduction(objPartOfProducton) {
      Log(this, this.EventSelectedPartOfProduction.name);
      this.selectedPartOfProduction = objPartOfProducton;
      this.selectedLineOfProduction = null;
      this.parteProduccionRealTrabajadorActivo = null;
      this.listProductionLine = [];
      if (objPartOfProducton === null) {
        return;
      }
      this.selectedPartOfProduction.LineasProduccion.forEach(
        (element) => this.listProductionLine.push(element.LineaProduccion),
      );
      if (this.listProductionLine.length === 1) {
        [this.selectedLineOfProduction] = this.listProductionLine;
      }
    },
    EventSelectedProductionLine(objLineOfProducton) {
      this.selectedLineOfProduction = objLineOfProducton;
    },
    async InitProductionPart() {
      Log(this, this.InitProductionPart.name);
      HiDialog.Preloader(true, 'Iniciando intervención', true, 'Inicio de intervención cancelada');
      try {
        const res = await APIErp.callInitWorkerInterventionInProductionPart(this.selectedWorker.Id, this.selectedPartOfProduction.Id, this.selectedLineOfProduction.Id);
        if (res.data.valor) {
          HiNotification.Toast(`Intervención iniciada ${res.data.mensaje}`);
          this.$refs.UCWorkersComponent.Clear();
        } else {
          HiNotification.Toast(`Intervención no iniciada ${res.data.mensaje}`, 10000);
        }
      } catch (e) {
        HiNotification.Toast(`Ocurrió un error al iniciar el parte de reparación ${e}`, 10000);
      }
      HiDialog.Preloader(false);
    },

    async FinishProductionPart() {
      Log(this, this.FinishProductionPart.name);
      HiDialog.Preloader(true, 'Finalizando intervención', true, 'Finalización de intervención cancelada');
      try {
        const res = await APIErp.callFinishWorkerInterventionInProductionPart(this.parteProduccionRealTrabajadorActivo.Id);
        if (res.data.valor) {
          HiNotification.Toast(`Intervención finalizada ${res.data.mensaje}`, res.data.mensaje !== '' ? 5000 : 2000);
          this.$refs.UCWorkersComponent.Clear();
        } else {
          HiNotification.Toast(`Intervención No finalizada ${res.data.mensaje}`, 10000);
        }
      } catch (e) {
        HiNotification.Toast(`Ocurrió un error al finalizar el parte de reparación ${e}`, 10000);
      }

      HiDialog.Preloader(false);
    },

    /* ****************** CONNECTIONS  ********************* ** */
    /* ********************************************************* */
    async Conections_GetActiveWorkerProductionPart(objWorker) {
      Log(this, this.Conections_GetActiveWorkerProductionPart.name);
      return new Promise((resolve, reject) => {
        APIErp.callActiveWorkerProductionPart(objWorker.Id)
          .then((result) => {
            resolve(result.data);
          })
          .catch((error) => {
            reject(error);
            LogError(this, this.Conections_GetActiveWorkerProductionPart.name, error);
          });
      });
    },
  },
};
</script>

<style lang="scss">
.main-repairs-interventions {
  // TODO: Remove when migrated to new styles
  --f7-button-padding-horizontal: 10px;
  --f7-button-height: 44px;
  --f7-button-small-height: 40px;
  --f7-card-header-font-size: 16px;
  --f7-card-header-font-weight: 400;
  --f7-card-header-min-height: 30px;
  --f7-card-header-color: #fff;
  --f7-card-header-padding-vertical: 4px;
  --f7-card-header-padding-horizontal: 16px;
  --f7-block-margin-vertical: 0;

  .card {
    border: 1px solid var(--f7-card-outline-border-color);
  }

  .card-header {
    color: var(--f7-card-header-color);
    font-size: var(--f7-card-header-font-size);
    font-weight: var(--f7-card-header-font-weight);
    text-transform: inherit;
    padding: var(--f7-card-header-padding-vertical) var(--f7-card-header-padding-horizontal);
    letter-spacing: 0;
  }

  .card-content-padding {
    padding: 6px 8px;
  }
  //
}

.content-tab {
  .tab-link-highlight {
    display: none;
  }

  .tab-link {
    border-right: 1px solid #ececec;
    border-bottom: 1px solid #ececec;

    .tabbar-label {
      color: var(--his-dark-blue);
      text-transform: none;
      font-size: 14px;
      opacity: 0.7;
      font-weight: 500;
    }
  }

  .tab-link-active {
    border-bottom: 4px solid var(--his-silver);
    background: linear-gradient(var(--his-coconut-milk), #fff);

    .tabbar-label {
      opacity: 1;
      font-size: 16px;
      font-weight: 700;
      color: var(--his-dark-blue);
    }
  }
}

.div-registroDeMarcaje {
  padding-top: 8px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--his-disabled);
}

.div-registrosDeMarcajes {
  background: #fff;
}

.div-componenteDeBusquedaTrabajador {
  min-height: 82px;
  background-color: var(--his-tierra-white);
  margin-top: -15px;
  padding-top: 15px;
  padding-bottom: 5px;
}

/** toolbar TAB */
.toolbar-pestañasTab {
  background: var(--his-tierra-white);
}

.img-iconoAccesoResumenActividadTrabajador {
  width: 28px;
  height: 28px;
  padding-top: 12px;
  padding-bottom: 0;
}

.disabled-component {
  opacity: 0.6;
  pointer-events: none;
}

.block-workerSelected {
  min-height: 100px;
}
</style>
